function isLocalStorageAvailable(): boolean {
  const key = "aiden-storage-test"
  try {
    localStorage.setItem(key, key)
    localStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}
function isSessionStorageAvailable(): boolean {
  const key = "aiden-storage-test"
  try {
    sessionStorage.setItem(key, key)
    sessionStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}

const getSessionStorage = (): Store =>
  isSessionStorageAvailable() ? sessionStorage : dummyStorage

const getLocalStorage = (): Store =>
  isLocalStorageAvailable()
    ? localStorage
    : isSessionStorageAvailable()
    ? sessionStorage
    : dummyStorage

export interface Store {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

const state: Record<string, string> = {}

const dummyStorage: Store = {
  getItem: (key) => state[key] || null,
  setItem: (key, value) => {
    state[key] = value
  },
  removeItem: (key) => {
    delete state[key]
  },
}

export const storage = {
  session: getSessionStorage(),
  local: getLocalStorage(),
}
